var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import "../../components/header";
import "../../components/leftMenu";
import "./add.css";
import "../../components/tag-input";
import * as authorization from "../../lib/authorization";
import * as ajax from "../../app-lib/ajax_proxy";
import { Configs } from '../../app-lib/constants';
var HeaderModel = /** @class */ (function (_super) {
    __extends(HeaderModel, _super);
    function HeaderModel(root) {
        var _this = _super.call(this, "/api/ice/local", root, { pid: 1 }) || this;
        _this.serverUrl = Configs.serviceUrl;
        _this.tags = ko.observableArray();
        _this.chosebtn = ko.observable(0);
        _this.XiangXi = ko.observable(0);
        _this.infoer = ko.observableArray([{ providerName: "", providerPhone: "" }]); //信息提供者
        _this.holder = ko.observableArray([{ holderName: "", holderNumber: "" }]); //持股人
        _this.cooperation = ko.observableArray(); //合作方式
        _this.copration = ko.observable(); //合作方式
        _this.projectname = ko.observable(""); //项目明称
        _this.projectaddress = ko.observable(""); //项目地点
        _this.projectarea = ko.observable(""); //项目面积
        _this.partarea = ko.observable(""); //一入伙面积
        _this.projecttext = ko.observable(""); //项目说明
        _this.ispool = ko.observable(false); //是否纳入信息池
        _this.ismys = ko.observable(0); //是否我方管理
        _this.hiddendiv = ko.observable(false); //控制持股人div
        _this.username = ko.observableArray(); //选择的关注人信息
        _this.userid = ko.observable(""); //当前用户id
        _this.localnext = ko.observable();
        _this.local = ko.observableArray();
        _this.localsomeid = ko.observable();
        _this.localid = ko.observable();
        _this.hiddenUser = ko.observable(false); //隐藏选择人员
        /////////////////// 详细地点 author  刘云哲
        _this.province = ko.observable("");
        _this.city = ko.observable("");
        _this.lableList = ko.observable([{ lableColor: ko.observable(''), lableDescription: ko.observable(''), dataId: '', selected: ko.observable(false) }]); //标签数组
        return _this;
    }
    //////////////  author  刘云哲 项目名重名
    HeaderModel.prototype.checkProjectName = function (root, e2) {
        var _this = this;
        ajax
            .get("/api/project/name", { projectName: this.projectname() })
            .then(function (d) {
            if (d.status == "0") {
                e2.target.setAttribute("style", "border-color:green");
            }
        })
            .catch(function (e) {
            if (e.status == "22") {
                var node = e2.target;
                node.setAttribute("style", "border-color:red");
                _this.projectname('');
                return window.popBox.show("项目名重名");
            }
        });
    };
    HeaderModel.prototype.checkProjectAdress = function (root, e2) {
        var _this = this;
        ajax.get("/api/pc/addr", {
            projectAddr: this.province() + "," + this.city() + "," + this.projectaddress()
        }).then(function (d) {
            if (d.status == "0") {
                e2.target.setAttribute("style", "border-color:green");
            }
        }).catch(function (e) {
            if (e.status == "22") {
                var node = e2.target;
                node.setAttribute("style", "border-color:red");
                window.popBox.show("详细地点重名").then(function () {
                    _this.projectaddress('');
                });
            }
        });
    };
    //弹框取消按钮
    HeaderModel.prototype.cancel = function (m, e) {
        if (this.chosebtn() == 1) {
            this.chosebtn(0);
        }
        else {
            this.chosebtn(1);
        }
    };
    HeaderModel.prototype.zkGengDuo = function (m, e) {
        var div = e.currentTarget.parentNode
            .nextElementSibling;
        if (!div.style.display || div.style.display == "block") {
            div.style.display = "none";
        }
        else {
            div.style.display = "block";
        }
    };
    HeaderModel.prototype.XiangXiZK = function (m, e) {
        var div = e.currentTarget.parentNode
            .parentNode.nextElementSibling;
        var div2 = div.nextElementSibling;
        if (!div.style.display || div.style.display == "none") {
            div.style.display = "block";
            div2.style.display = "block";
        }
        else {
            div.style.display = "none";
            div2.style.display = "none";
        }
    };
    HeaderModel.prototype.GengDuo = function (m, e) {
        var div = e.currentTarget
            .nextElementSibling;
        if (!div.style.display || div.style.display == "none") {
            div.style.display = "block";
        }
        else {
            div.style.display = "none";
        }
    };
    //省份二级联动
    HeaderModel.prototype.changelocal = function () {
        var _this = this;
        var id = this.localid().id;
        ajax.get("/api/ice/local", { pid: id }).then(function (d) {
            _this.localnext(d.data);
        });
    };
    //城市改变
    HeaderModel.prototype.changelocalsome = function () {
        this.province(this.localid().name);
        this.city(this.localsomeid().name);
        var loc = this.localid().name + "," + this.localsomeid().name;
    };
    //合作方式改变
    HeaderModel.prototype.corpchange = function () {
        if (this.copration() == "股权合作") {
            this.hiddendiv(true);
            this.container.querySelector("#shou").setAttribute("placeholder", "请输入公司名");
        }
        else if (this.copration() != "股权合作") {
            this.hiddendiv(false);
            this.container.querySelector("#shou").setAttribute("placeholder", "请输入项目名称");
        }
    };
    //是否纳入信息池
    // ispools() {
    //   this.ispool(1);
    //   if (this.ispool() == 1) {
    //     this.hiddenUser(true);
    //   }else{
    //   }
    //   console.log('aaaa:'+this.ispool());
    // }
    //是否我方管理
    HeaderModel.prototype.ismy = function () {
        this.ismys(1);
    };
    //提交项目信息
    HeaderModel.prototype.submitbtn = function () {
        var _this = this;
        var informations = "";
        var userIdages = [];
        for (var index in this.tags()) {
            userIdages[index] = this.tags()[index].username;
        }
        //项目信息验证
        if (this.copration() == "" ||
            this.copration() == undefined ||
            this.copration() == null) {
        }
        //项目名称验证
        if (this.projectname() != null && this.projectname().length > 30) {
            informations = informations + "  项目名称过长!! <br>";
        }
        if (this.projectname().trim() == "") {
            informations = informations + "  项目名称未填写!! <br>";
        }
        if (this.projectaddress().trim() == "" ||
            this.projectaddress() == undefined) {
            informations = informations + "  请输入项目详细地址!! <br>";
        }
        if (this.partarea().trim() == "") {
            informations = informations + "  请输入已入伙面积!!<br>";
        }
        if (isNaN(Number(this.partarea()))) {
            informations = informations + "  已入伙面积输入有误!!<br>";
        }
        if (this.partarea().length > 12) {
            informations = informations + "  已入伙面积太大!!<br>";
        }
        if (this.projectarea().trim() == "") {
            informations = informations + "  请输入建筑面积!!<br>";
        }
        if (isNaN(Number(this.projectarea()))) {
            informations = informations + "  建筑面积输入有误!!<br>";
        }
        if (this.projectarea().length > 12) {
            informations = informations + "  建筑面积太大!!<br>";
        }
        var cover = parseFloat(this.projectarea());
        var join = parseFloat(this.partarea());
        if (cover < join) {
            informations = informations + "  入伙面积不得大于建筑面积!!<br>";
        }
        //持股人验证
        var a = 0;
        var per = 0;
        if (this.copration() == "股权合作") {
            for (var _i = 0, _a = this.holder(); _i < _a.length; _i++) {
                var holdList = _a[_i];
                a = a + 1;
                if (holdList.holderName == "") {
                    informations =
                        informations + "第" + a + "个持股人没有填写姓名!! <br>";
                }
                if (holdList.holderNumber == "" ||
                    holdList.holderNumber == undefined ||
                    holdList.holderNumber == null) {
                    informations = informations + " 第" + a + "个持股数为空!!<br> ";
                }
                else {
                    if (Number(holdList.holderNumber) == NaN) {
                        informations = informations + " 第" + a + "个持股数应为纯数字!!<br> ";
                    }
                    else {
                        per = parseInt(holdList.holderNumber) + per;
                    }
                }
            }
            if (per < 100) {
                informations = informations + " 持股比例和应为100%!!<br>";
            }
            else if (per > 100) {
                informations = informations + "  持股比例之和超过100!!<br>";
            }
        }
        //信息提供者验证
        var inf = 0;
        for (var _b = 0, _c = this.infoer(); _b < _c.length; _b++) {
            var infoList = _c[_b];
            inf = inf + 1;
            if (infoList.providerName == "") {
                informations = informations + " 第" + inf + "个未填写信息提供者!!<br>";
            }
            var phone = /^[1][3,4,5,7,8][0-9]{9}$/;
            var guhua = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
            if (phone.test(infoList.providerPhone) || guhua.test(infoList.providerPhone)) {
            }
            else {
                informations = informations + " 第" + inf + "信息提供者电话格式错误或未填写!<br>";
                break;
            }
        }
        if (informations.trim() != "") {
            window.popBox.show(informations);
            return;
        }
        var isp = "";
        if (this.ispool()) {
            isp = null;
            userIdages = [];
        }
        else {
            isp = authorization.getUserId();
        }
        var ism = "";
        if (this.ismys()) {
            ism = "1";
        }
        else {
            ism = "0";
        }
        //地点拼接
        var loc = this.localid().name +
            "," +
            this.localsomeid().name +
            "," +
            this.projectaddress();
        var pLabel = '';
        for (var i = 0; i < this.lableList().length; i++) {
            if (this.lableList()[i].selected()) {
                if (pLabel.length < 1) {
                    pLabel = this.lableList()[i].dataId;
                }
                else {
                    pLabel = pLabel + ',' + this.lableList()[i].dataId;
                }
            }
        }
        ajax.post("/api/pc/project", {
            cooperationMode: this.copration(),
            projectName: this.projectname(),
            projectAddr: loc,
            projectArea: this.projectarea(),
            projectParts: this.partarea(),
            projectOwner: isp,
            projectSource: "PC端",
            projectInputer: authorization.getUserId(),
            noticerId: userIdages,
            provider: this.infoer(),
            projectComment: this.projecttext(),
            projectManager: ism,
            holder: this.holder(),
            projectLabel: pLabel //标签
        })
            .then(function (d) {
            if (d.status == 22) {
                _this.projectname(''); //项目名称重复提示后清空
                return window.popBox.show("项目名重复!");
            }
            else if (d.status == 0) {
                _this.loadbubble();
                _this.loadnum();
                window.popBox.show("项目创建成功").then(function () {
                    var tag = _this.container.querySelector('.add-frame-center-line-input');
                    tag.setAttribute("style", "border-color:#cccccc"); //add-frame-center-line-input-address
                    var tag1 = _this.container.querySelector('.add-frame-center-line-input-address');
                    tag1.setAttribute("style", "border-color:#cccccc"); //
                    //新增之后清空项目信息
                    _this.infoer([{ providerName: "", providerPhone: "" }]); //信息提供者
                    _this.holder([{ holderName: "", holderNumber: "" }]); //持股人
                    _this.ismys(0); //是否我方管理
                    _this.ispool(false); //是否纳入信息池
                    _this.projectname(""); //项目名称
                    _this.projectaddress(""); //项目地点
                    _this.projectarea(""); //项目面积
                    _this.partarea(""); //一入伙面积
                    _this.projecttext(""); //项目说明
                    _this.cooperation([{}]); //合作方式
                    _this.tags.removeAll(); //关注人
                    //新增项目后跳转的页面
                    if (isp == null) {
                        window.open("#/information/information", '_parent');
                    }
                    else {
                        window.open("#/project/Myproject", '_parent');
                    }
                });
            }
        });
    };
    // 获取标签列表
    HeaderModel.prototype.getLableList = function () {
        var _this = this;
        ajax.get('/api/label').then(function (d) {
            _this.lableList([]);
            for (var n = 0; n < d.data.length; n++) {
                _this.lableList().push({ lableColor: ko.observable(''), lableDescription: ko.observable(''), dataId: '', selected: ko.observable(false) });
            }
            _this.lableList(_this.lableList());
            for (var i = 0; i < _this.lableList().length; i++) {
                _this.lableList()[i].lableDescription(d.data[i].name);
                _this.lableList()[i].lableColor(d.data[i].colour);
                _this.lableList()[i].dataId = d.data[i].id;
                // this.lableList()[i].selected = d.data[i].id;
            }
        });
    };
    // 选择标签
    HeaderModel.prototype.selectLabel = function (d, r) {
        console.log(d, r);
        var m = 0;
        for (var i = 0; i < this.lableList().length; i++) {
            if (this.lableList()[i].selected()) {
                m++;
            }
        }
        if (this.lableList()[d].selected()) {
            this.lableList()[d].selected(false);
        }
        else {
            if (m < 5) {
                this.lableList()[d].selected(true);
            }
            else {
                return window.popBox.show('最多选择五个标签');
            }
        }
    };
    //保存草稿
    HeaderModel.prototype.localbt = function () {
        var localst = window.localStorage;
        //地点拼接
        var loc = this.localid().name +
            "," +
            this.localsomeid().name +
            "," +
            this.projectaddress();
        localst["projectname"] = this.projectname();
        localst["copration"] = this.copration();
        localst["projectarea"] = this.projectarea();
        localst["partarea"] = this.partarea();
        localst["projectaddress"] = loc;
        localst["ispool"] = this.ispool();
        localst["projecttext"] = this.projecttext();
        window.popBox.show("部分草稿已经保存");
    };
    //增删信息提供者弹框
    HeaderModel.prototype.removeinfo = function (troot, tindex) {
        if (tindex == "0") {
            this.infoer.push({ providerName: "", providerPhone: "" });
        }
        this.infoer.splice(tindex, 1);
    };
    HeaderModel.prototype.addinfor = function () {
        if (this.infoer().length < 2) {
            this.infoer.push({ providerName: "", providerPhone: "" });
        }
    };
    //增删持股人弹框
    HeaderModel.prototype.removehold = function (troot, tindex) {
        if (tindex == "0") {
            this.holder.push({ holderName: "", holderNumber: "" });
        }
        this.holder.splice(tindex, 1);
    };
    HeaderModel.prototype.addhold = function () {
        this.holder.push({ holderName: "", holderNumber: "" });
    };
    //重置表单
    HeaderModel.prototype.resetbtn = function () {
        var _this = this;
        for (var i = 0; i < this.lableList().length; i++) {
            this.lableList()[i].selected(false);
        }
        this.cooperation([{}]); //合作方式
        this.infoer([{ providerName: "", providerPhone: "" }]); //信息提供者
        this.holder([{ holderName: "", holderNumber: "" }]); //持股人
        this.ismys(0); //是否我方管理
        this.ispool(false); //是否纳入信息池
        this.projectname(""); //项目名称
        this.projectaddress(""); //项目地点
        this.projectarea(""); //项目面积
        this.partarea(""); //一入伙面积
        this.projecttext(""); //项目说明
        this.tags.removeAll(); //关注人
        ajax.get('/api/project/type')
            .then(function (d) {
            d.data = d.data.reverse();
            _this.cooperation(d.data);
        });
    };
    // ie设置
    HeaderModel.prototype.ieS = function () {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
        var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
        var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
        // debugger;
        if (isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            if (fIEVersion == 7) {
                var input1 = this.container.querySelector('#addInput');
                input1.className = '11';
                input1.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
            }
            else if (fIEVersion == 8) {
                var input1 = this.container.querySelector('#addInput');
                input1.className = '11';
                input1.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
            }
            else if (fIEVersion == 9) {
                var input1 = this.container.querySelector('#addInput');
                input1.className = '11';
                input1.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
            }
            else if (fIEVersion == 10) {
                var input1 = this.container.querySelector('#addInput');
                input1.className = '11';
                input1.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
            }
            else {
                var input1 = this.container.querySelector('#addInput');
                input1.className = '11';
                input1.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
            }
        }
        else if (isEdge) {
            var input1 = this.container.querySelector('#addInput');
            input1.className = '11';
            input1.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
        }
        else if (isIE11) {
            var input1 = this.container.querySelector('#addInput');
            input1.className = '11';
            input1.setAttribute('style', 'margin-top:10px;margin-left:5px;float:left;');
        }
        else {
            // return -1;//不是ie浏览器           
        }
        // }
    };
    HeaderModel.prototype.loadbubble = function () {
        var arr = [];
        for (var i = 0; i < 7; i++) {
            arr.push(localStorage.getItem(i.toString()));
        }
        return ajax.post('/api/statistics/smessage', { userId: authorization.getUserId(), time: arr }).then(function (d) {
            ko.postbox.publish('leftMenu_myProject', d.data.count0);
            ko.postbox.publish('leftMenu_myFollowProject', d.data.count1);
            ko.postbox.publish('leftMenu_noFollowNews', d.data.count2);
            ko.postbox.publish('leftMenu_waitProjectNews', d.data.count3);
            ko.postbox.publish('leftMenu_signgedProjectNews', d.data.count4);
            ko.postbox.publish('leftMenu_abandonProjectNews', d.data.count5);
            ko.postbox.publish('leftMenu_auditMessage', d.data.count6);
        });
    };
    HeaderModel.prototype.loadnum = function () {
        return ajax.get('/api/statistics/message', { userid: authorization.getUserId(), loginTime: new Date()["Format"]('yyyy-MM-dd hh:mm:ss') }).then(function (d) {
            ko.postbox.publish('leftMenu_allProject', d.data.allProject);
            ko.postbox.publish('leftMenu_followProject', d.data.followProject);
            ko.postbox.publish('leftMenu_nofollow', d.data.nofollow);
            ko.postbox.publish('leftMenu_waitProject', d.data.waitProject);
            ko.postbox.publish('leftMenu_signgedProject', d.data.signgedProject);
            ko.postbox.publish('leftMenu_abandonProject', d.data.abandonProject);
            ko.postbox.publish('leftMenu_noReadProject', d.data.noReadProject);
        });
    };
    HeaderModel.prototype.load = function () {
        return Promise.all([this.loadnum(), this.loadbubble(), this.loadData()]).then(function () { });
    };
    HeaderModel.prototype.onViewModelSetting = function (d) {
        this.local(d.data);
        this.getLableList(); //获取标签列表
        return Promise.resolve(false);
    };
    return HeaderModel;
}(KnockoutModel));
var mModel = /** @class */ (function (_super) {
    __extends(mModel, _super);
    function mModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    mModel.prototype.init = function () {
        this.hm = new HeaderModel(this.container.querySelector(".Myproject"));
    };
    mModel.prototype.update = function (arg) {
        var _this = this;
        this.hm.ieS();
        this.hm.username.removeAll();
        this.hm.cooperation([{}]); //合作方式
        this.hm.infoer([{ providerName: "", providerPhone: "" }]); //信息提供者
        this.hm.holder([{ holderName: "", holderNumber: "" }]); //持股人
        this.hm.ismys(0); //是否我方管理
        this.hm.ispool(false); //是否纳入信息池
        this.hm.projectname(""); //项目名称
        this.hm.projectaddress(""); //项目地点
        this.hm.projectarea(""); //项目面积
        this.hm.partarea(""); //一入伙面积
        this.hm.projecttext(""); //项目说明
        this.hm.tags.removeAll(); //关注人
        this.hm.userid(window.localStorage.getItem("UserId"));
        ajax.get('/api/project/type')
            .then(function (d) {
            if (d.data) {
                d.data = d.data.reverse();
                _this.hm.cooperation(d.data);
            }
            else {
                _this.hm.cooperation([]);
            }
        });
        //系统日志
        ajax.post('/api/log/add', { userId: authorization.getUserId(), logMessage: "新增项目" });
        // 
        return this.hm.load();
    };
    return mModel;
}(Page));
export default mModel;
